import { render, staticRenderFns } from "./SharingMetadata.vue?vue&type=template&id=fd6a16d2&"
import script from "./SharingMetadata.vue?vue&type=script&lang=js&"
export * from "./SharingMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports